import React from 'react';
import { connect } from 'react-redux';
import {push} from "react-router-redux";
import {Link} from "react-router";
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_CHAMPIONSHIP, ROUTE_CHAMPIONSHIPS, ROUTE_CLUB} from '../../../constants/routeconstants';
import * as AdminActions from "../../../actions/admin";

import { confirm } from '../../../utils/confirmDialog';
import {CompressList, nullToBlank} from "../../../../../common/src/util/lib";
import UserFieldElement from "../../reusable/UserFieldElement";
import UserFieldDataType from "../../../utils/enums/UserFieldDataTypeEnum";

class ChampionshipsPage extends React.Component {

    static getId() {
        return ROUTE_CHAMPIONSHIPS;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            sort: 'Nr',
        }
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getChampionships());
    }

    render() {
        return this.props.admin.isChampionshipsRead ?
            <div>
                <div className="sub-page-title">
                    <h2>Mesterskaber</h2>
                </div>
                <div className="sub-page-content">
                    <table className="data-table championships-overview">
                        <thead>
                            <tr>
                                <th scope="row" className="clickable" onClick={() => {this.setState({sort: 'Nr'})}}>Kode</th>
                                <th className="clickable" onClick={() => {this.setState({sort: 'Titel'})}}>Navn</th>
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektionsgrupper</th> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektioner</th> : null}
                                {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Områder</th> : null}
                                <th className="clickable" onClick={() => {this.setState({sort: 'Type'})}}>Type</th>
                                <th>Pointsystem</th>
                                <th></th>
                                <th>Lag</th>
                                <th>Juniorer</th>
                                <th>Begyndere</th>
                                <th>Sportsduer</th>
                                <th>Markerede</th>
                                <th>DM-duer</th>
                                <th>Kun markering</th>
                                <th>Årgang</th>
                                <th>Duer pr slag</th>
                                <th>Procent duer</th>
                                <th>Antal flyvn.</th>
                                <th>Landsflyvn.</th>
                                <th>Maks</th>
                                <th>Langflyvn.</th>
                                <th>Maks.</th>
                                <th>Mellemflyvn.</th>
                                <th>Maks.</th>
                                <th>Diplomer</th>
                                <th className={'sticky-actions-head'}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.admin.championships.filter(c => this.state.filter === '' ? true :
                                nullToBlank(c.Nr).toUpperCase().search(this.state.filter) >= 0 ||
                                nullToBlank(c.Titel).toUpperCase().search(this.state.filter) >= 0 ||
                                nullToBlank(c.Type).toUpperCase().search(this.state.filter) >= 0
                            ).sort((c1, c2) =>{
                                if (c1.Nr === null) return 1;
                                if (c2.Nr === null) return -1;
                                const comp = (c1[this.state.sort] === null ? '' : c1[this.state.sort].trim()).localeCompare(c2[this.state.sort] === null ? '' : c2[this.state.sort].trim(), 'da-DK');
                                return comp === 0 ? (c1.Nr < c2.Nr ? -1 : c1.Nr > c2.Nr ? 1 : 0) : comp;
                            }).toArray().map(championship => {
                                const sections = CompressList(championship.Sektioner);
                                const groups = CompressList(championship.Sektionsgrupper);

                                return <tr key={championship.RecNr} className={""} onDoubleClick={() => {
                                    this.props.dispatch(push(ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'view')));
                                }}>
                                    <th scope="row">{championship.Nr}</th>
                                    <td>{championship.Titel}</td>
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{groups.items.join(',')}</td> : null}
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{sections.items.join(',')}</td> : null}
                                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{championship.Omraader}</td> : null}
                                    <td>{championship.Type}</td>
                                    <td>{championship.Pointsystem}</td>
                                    <td>{championship.Pointsystem2}</td>
                                    <td>{championship.LagMellem}</td>
                                    <td className={'boolean'}>{championship.KunJuniorer ? 'X' : null}</td>
                                    <td className={'boolean'}>{championship.KunBegyndere ? 'X' : null}</td>
                                    <td className={'boolean'}>{championship.KunSportsduer ? 'X' : null}</td>
                                    <td className={'boolean'}>{championship.KunDuemarkerede ? 'X' : null}</td>
                                    <td className={'boolean'}>{championship.KunDmDuer ? 'X' : null}</td>
                                    <td>{championship.Foreningsmarkering1}</td>
                                    <td>{championship.Aargang}</td>
                                    <td>{championship.AntalDuerPrSlag}</td>
                                    <td>{championship.MinPlacKoefficient}</td>
                                    <td>{championship.AntalFlyvninger}</td>
                                    <td>{championship.MinAntal91Flyvninger}</td>
                                    <td>{championship.Antal91Flyvninger}</td>
                                    <td>{championship.MinAntal_L_flyvninger}</td>
                                    <td>{championship.Antal_L_flyvninger}</td>
                                    <td>{championship.MinAntal_M_flyvninger}</td>
                                    <td>{championship.Antal_M_flyvninger}</td>
                                    <td>{championship.AntalDiplomer}</td>
                                    <th className={'sticky-actions'}>
                                        <div className={'actions-container'}>
                                            <Link to={ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'view')} title="Vis detaljer">
                                                <i className="fa fa-file-text-o"/>
                                            </Link>
                                            <Link to={ROUTE_CHAMPIONSHIP.replace(':championshipNo', championship.RecNr).replace(':subpage', 'general').replace(':mode', 'edit')} title="Rediger forening">
                                                <i className="fa fa-pencil"/>
                                            </Link>
                                            <i className={"fa fa-trash pointer clickable"} title="Slet forening" onClick={() => {
                                                confirm("Slet", <span>Ønsker du at slette mesterskabet <b>{championship.Titel} ({championship.Nr})</b>?</span>, () => {
                                                    this.props.dispatch(AdminActions.deleteChampionship(championship.RecNr, () => {
                                                        NotificationManager.success("Mesterskaber " + championship.Nr + " (" + championship.Titel + ") er slettet.", "Sletning", 4000);
                                                    }));
                                                });
                                            }}/>
                                        </div>
                                    </th>
                                </tr>
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="sub-page-actions">
                    <Link className={"btn-primary"} to={ROUTE_CHAMPIONSHIP.replace(':championshipNo', 'new').replace(':subpage', 'general').replace(':mode', 'create')} title="Opret nyt mesterskab">
                        Ny
                    </Link>
                    <label htmlFor="filter">Filter</label>
                    <UserFieldElement dataType={UserFieldDataType.string} placeholder="Indtast søgeværdi" className="field-1 large-field"
                                      name="filter" id="filter"
                                      autoCheckErrors={true} required={false} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={(e) => {
                                          const val = e.target.value.toUpperCase();
                                          //this.onStandardFieldChange(e);
                                          if (this.timeoutHandler !== null) clearTimeout(this.timeoutHandler);
                                          this.timeoutHandler = setTimeout(() => {
                                              this.setState({filter: val});
                                          }, 500);
                                      }}
                    />
                    <label htmlFor="sort">Sortering</label>
                    <UserFieldElement dataType={UserFieldDataType.enum} placeholder="false" className="field-1 large-field"
                                      name="sort" id="sort" value={this.state.sort} options={[
                                        {key: 'Nr', value: 'Kode'},
                                        {key: 'Titel', value: 'Navn'},
                                        {key: 'Type', value: 'Type'},
                                      ]}
                                      autoCheckErrors={true} required={true} hideErrWhenFocused={true} hideErrUntilFocused={true}
                                      onChange={this.onStandardFieldChange}
                    />
                </div>
            </div> : null;
    }

    timeoutHandler = null;

    onStandardFieldChange = (e) => {
        const stateVariable = e.target.name;
        this.setState({[stateVariable]: e.target.value});
    };
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        isChampionshipsRead: state.admin.isChampionshipsRead,
        championships: state.admin.championships,
    }
});

export default connect(mapStateToProps)(ChampionshipsPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/championships/ChampionshipsPage.js